/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratoremployeerelated3Inputs */

const en_settings_collaborators_invitecollaboratoremployeerelated3 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratoremployeerelated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employee related`)
};

/**
* | output |
* | --- |
* | "Employee related" |
*
* @param {Settings_Collaborators_Invitecollaboratoremployeerelated3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratoremployeerelated3 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratoremployeerelated3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratoremployeerelated3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratoremployeerelated3(inputs)
});
export { settings_collaborators_invitecollaboratoremployeerelated3 as "settings_collaborators_inviteCollaboratorEmployeeRelated" }